// drivers.js
import req from './axios';
import { isMockJs } from './axios'

export const exportHistory = (id, sendData) => req('get', isMockJs ? '/export/exportHistory' : `/configuration/${id}/export/`,sendData);